"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveStringIntl = exports.useStringIntl = exports.useFormatter = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const intl_messageformat_1 = require("intl-messageformat");
const locale_1 = require("utils/locale");
const localeProvider_1 = require("./localeProvider");
const formatString = (str, values) => {
    if (!values) {
        return str;
    }
    else if (str) {
        const format = new intl_messageformat_1.IntlMessageFormat(str);
        const output = format.format(values);
        return typeof output === "string" ? output : undefined;
    }
    else {
        return undefined;
    }
};
const useFormatter = () => {
    const [locale] = (0, localeProvider_1.useContextLocale)();
    const getMessage = (id, defaultMessage) => {
        var _a;
        return ((id && (((_a = locale_1.messages[locale]) === null || _a === void 0 ? void 0 : _a[id]) || locale_1.messages.ja[id])) ||
            defaultMessage);
    };
    const dateFormatter = (id, defaultMessage, value) => {
        const dateFormat = getMessage(id, defaultMessage);
        return value && (0, dayjs_1.default)(value).format(dateFormat);
    };
    return {
        formatDate: dateFormatter.bind(null, "DateFormat", "YYYY-MM-DD"),
        formatDateTime: dateFormatter.bind(null, "DateTimeFormat", "YYYY-MM-DD HH:mm:ss"),
        formatMessage: (id, values) => {
            const message = getMessage(id);
            return formatString(message, values) || "";
        },
        formatString: (value, id, values = {}) => {
            const message = (0, exports.resolveStringIntl)(value, locale) || getMessage(id);
            return formatString(message, values);
        },
    };
};
exports.useFormatter = useFormatter;
// formatStringと重複しているので、削除を検討。
function useStringIntl() {
    const [locale] = (0, localeProvider_1.useContextLocale)();
    return ((value) => {
        return (0, exports.resolveStringIntl)(value, locale);
    });
}
exports.useStringIntl = useStringIntl;
const resolveStringIntl = (value, locale) => {
    if (typeof value === "string") {
        return value;
    }
    else if (!value) {
        return undefined;
    }
    else {
        return value[locale || "ja"] || (value === null || value === void 0 ? void 0 : value["ja"]);
    }
};
exports.resolveStringIntl = resolveStringIntl;
